/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PatchedLink from '../partials/PatchedLink';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/link.scss';

const propTypes = {
    url: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    url: null,
    label: null,
    className: null,
};

const LinkBlock = ({ url, label, className }) =>
    url !== null ? (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <PatchedLink className={styles.link} url={url} label={label} external />
        </div>
    ) : null;

LinkBlock.propTypes = propTypes;
LinkBlock.defaultProps = defaultProps;

export default LinkBlock;
